// extracted by mini-css-extract-plugin
export default {"chart":"chart__ZBWHHoiw","segmentFilter":"segment-filter__s9J0E_GR"};